<template>
    <HeadlessTransitionRoot
        :show="isOpen"
        as="template"
    >
        <HeadlessDialog
            as="div"
            class="relative z-[100]"
            @close="setIsOpen"
        >
            <HeadlessTransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black bg-opacity-25">
                    <MouseFollower :hide-when-over-el="dialogPanelEl" />
                </div>
            </HeadlessTransitionChild>

            <div class="fixed bottom-0 left-0 top-0 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <HeadlessTransitionChild
                        as="template"
                        enter="duration-300 ease-out"
                        enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100"
                        leave="duration-200 ease-in"
                        leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95"
                    >
                        <HeadlessDialogPanel class="w-full max-w-2xl rounded-2xl shadow-xl transition-all">
                            <div
                                ref="dialogPanelEl"
                                class="document w-full rounded-2xl bg-whitegray p-8 text-left text-lg whitespace-pre-line"
                            >
                                <div v-if="userCredentials.isAuthenticated">
                                    Вы уверены, что хотите очистить текущую корзину и добавить в нее товары из сохраненной?

                                    <div class="flex gap-4 items-center mt-8">
                                        <SimpleButton
                                            class="w-full px-4 py-4 text-xs uppercase"
                                            type="button"
                                            @click="fillCart"
                                        >
                                            Да, добавить товары
                                        </SimpleButton>
                                        <button @click="setIsOpen(false)" type="button" class="text-orange-200 flex-shrink-0"> Нет, не менять корзину </button>
                                    </div>
                                </div>
                                <div v-else>
                                    <div>Для загрузки сохраненной корзины необходимо авторизоваться</div>

                                    <div class="flex gap-4 items-center mt-8">
                                        <SimpleButton
                                            class="px-4 py-4 text-xs uppercase flex-shrink-0"
                                            type="button"
                                            @click="auth"
                                        >
                                            Войти в аккаунт
                                        </SimpleButton>
                                        <button @click="setIsOpen(false)" type="button" class="text-orange-200 flex-shrink-0"> Закрыть окно </button>
                                    </div>
                                </div>
                            </div>
                        </HeadlessDialogPanel>
                    </HeadlessTransitionChild>
                </div>
            </div>
        </HeadlessDialog>
    </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import usePrivateAxiosInstance from '~/composables/usePrivateAxiosInstance'
import { ref } from 'vue'
import { useFillFromSaved } from '~/composables/api/basket'
import { useAuthDialogStore } from '~/store/authDialog'

const route = useRoute()
const sharedCartId = route.params.shared_cart_id as string
const isOpen = ref(parseInt(sharedCartId) > 0)
const dialogPanelEl = ref()
const privateAxios = usePrivateAxiosInstance()
const { mutate } = useFillFromSaved()

const { userCredentials } = useUserCredentials()
const authDialogStore = useAuthDialogStore()

function setIsOpen(value: boolean) {
    isOpen.value = value
}

async function fillCart() {
    setIsOpen(false)
    mutate(parseInt(sharedCartId), {
        onSuccess: () => {
            history.pushState({}, null, "/"); //change page url so refreshing page not show dialog again
        }
    })
}

async function auth() {
    setIsOpen(false)
    authDialogStore.open()
}

</script>
